import React, { useState, useEffect } from 'react'
import Datepicker from 'gatsby-theme-kn/src/components/technical/Datepicker'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceOrders = () => {
  const { t } = useTranslation()
  const date = new Date()
  const [InputData, setInputData] = useState({
    customer_number: '',
    number: '',
    submission_number: '',
    consignee: '',
    consignee_street: '',
    consignee_zipcode: '',
    consignee_city: '',
    fixed_date: '',
    garbio_file: '',
  })
  const [Fdata, setFdata] = useState(false)

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )

  const FormSubmit = (e) => {
    e.preventDefault()

    const data = new FormData()
    data.append('orders[customer_number]', InputData.customer_number)
    data.append('orders[number]', InputData.number)
    data.append('orders[submission_number]', InputData.submission_number)
    data.append('orders[consignee]', InputData.consignee)
    data.append('orders[consignee_street]', InputData.consignee_street)
    data.append('orders[consignee_zipcode]', InputData.consignee_zipcode)
    data.append('orders[consignee_city]', InputData.consignee_city)
    data.append('orders[fixed_date]', InputData.fixed_date)
    data.append('orders[garbio_file]', InputData.garbio_file)

    setFdata(data)
    setPartnerPortalUrl(apiURL('orders'))

    return true
  }

  useEffect(() => {
    if (data && data.id) {
      if (typeof window !== 'undefined') {
        window.location.href = window.location.href + '?id=' + data.id
      }
    }
  }, [data])

  return (
    <div className="spa-block-full" data-spa-type="orders">
      {loading && <LoadingSpinner />}
      {!loading && (
        <form
          className=""
          encType="multipart/form-data"
          onSubmit={(e) => FormSubmit(e)}
        >
          <div className="mb-1" data-needs-role="sap_enter_customer_number">
            <label htmlFor="customer_number">
              <sup>*</sup> {t('generic.spa.customer_number')}
            </label>
            <input
              type="text"
              className="form-control"
              name="customer_number"
              required
              autoFocus
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  customer_number: e.target.value,
                })
              }
            />
            <div className="invalid-feedback">
              {t('generic.spa.customer_number_hint')}
            </div>
          </div>
          <div className="mb-1 required">
            <label htmlFor="number">
              <sup>*</sup> {t('generic.spa.order.order_number')}
            </label>
            <input
              type="text"
              className="form-control"
              name="number"
              required
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  number: e.target.value,
                })
              }
            />
            <div className="invalid-feedback">
              {t('generic.spa.order.order_number_hint')}
            </div>
          </div>
          <div className="mb-1">
            <label htmlFor="submission_number">
              {t('generic.spa.order.submission_number')}
            </label>
            <input
              type="text"
              className="form-control"
              name="submission_number"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  submission_number: e.target.value,
                })
              }
            />
          </div>
          <h3>{t('generic.spa.order.consignee')}</h3>
          <div className="mb-1">
            <label htmlFor="consignee">
              {t('generic.spa.order.consignee_name')}
            </label>
            <input
              type="text"
              className="form-control"
              name="consignee"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  consignee: e.target.value,
                })
              }
            />
          </div>
          <div className="mb-1">
            <label htmlFor="consignee_street">
              {t('generic.spa.order.consignee_street')}
            </label>
            <input
              type="text"
              className="form-control"
              name="consignee_street"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  consignee_street: e.target.value,
                })
              }
            />
          </div>
          <div className="mb-1">
            <label htmlFor="consignee_zipcode">
              {t('generic.spa.order.consignee_zipcode')}
            </label>
            <div className="row">
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  name="consignee_zipcode"
                  onChange={(e) =>
                    setInputData({
                      ...InputData,
                      consignee_zipcode: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control"
                  name="consignee_city"
                  onChange={(e) =>
                    setInputData({
                      ...InputData,
                      consignee_city: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
          <div className="mb-1">
            <label htmlFor="fixed_date">
              {t('generic.spa.order.fixed_date')}
            </label>
            <Datepicker
              selected={InputData.fixed_date}
              name="fixed_date"
              value={InputData.fixed_date}
              onChange={(date) =>
                setInputData({
                  ...InputData,
                  fixed_date: date,
                })
              }
            />
          </div>
          <div className="mb-1 required">
            <label htmlFor="garbio_file">
              {t('generic.spa.order.garbio_file')}
            </label>
            <input
              type="file"
              className="form-control"
              name="garbio_file"
              required
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  garbio_file: e.target.files[0],
                })
              }
            />
          </div>
          <button className="btn btn-primary btn-sm mt-1" type="submit">
            {t('generic.spa.order.submit')}
          </button>
        </form>
      )}
    </div>
  )
}

export default SapServiceOrders
